
/* =====================================================================
   DIDHARA — Zoom dentro da imagem (substitui a lupa do tema)
   Só em aparelhos com mouse. No celular nada muda.
   ===================================================================== */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function attach(host) {
    if (host.dataset.ddZoom) return;
    var img = host.querySelector('img.product-gallery__image');
    if (!img) return;
    host.dataset.ddZoom = '1';
    host.classList.add('dd-zoom-host');

    var layer = document.createElement('div');
    layer.className = 'dd-zoom-layer';
    host.appendChild(layer);

    host.addEventListener('mouseenter', function () {
      var src = img.getAttribute('data-zoom') || img.currentSrc || img.src;
      if (src && layer.dataset.src !== src) {
        layer.style.backgroundImage = 'url("' + src + '")';
        layer.dataset.src = src;
      }
      host.classList.add('is-zooming');
    });
    host.addEventListener('mousemove', function (e) {
      var r = host.getBoundingClientRect();
      var x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
      var y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
      layer.style.backgroundPosition = x + '% ' + y + '%';
    });
    host.addEventListener('mouseleave', function () {
      host.classList.remove('is-zooming');
    });
  }

  function init() {
    document.querySelectorAll('.product-gallery__carousel .aspect-ratio').forEach(attach);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
